import React from 'react';
import { Create } from 'react-admin';

import SupplyTypeForm from './SupplyTypeForm';
import ErrorBoundary from '../ErrorBoundary';

const SupplyTypeCreate = props => (
    <ErrorBoundary>
        <Create {...props} title="New Supply Type">
            <SupplyTypeForm redirect="list" />
        </Create>
    </ErrorBoundary>
);

export default SupplyTypeCreate;
